const url = [
  // 登录页面 注册页面 密码找回页面
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/auth/Login.vue')
  }, {
    path: '/error404',
    name: 'Error 404',
    index: 2,
    component: () => import('@/views/error/Error404.vue')
  }, {
    path: '/register',
    name: 'Register',
    index: 3,
    component: () => import('@/views/auth/Register.vue')
  }, {
    path: '/forgot',
    name: 'Forgot',
    index: 4,
    component: () => import('@/views/auth/Forgot.vue')
  },{
    path: '/wxChat.html',
    name: 'wxChat.html',
    index: 5,
    component: () => import('@/views/weixin/WxChat.vue')
  },{
    path: '/wxscan',
    name: 'wxscan',
    index: 5,
    component: () => import('@/views/weixin/WxScan.vue')
  },

  //根页面
  {
    path: '/rootmain',
    component: () => import('@/layout/RootMain.vue'),
    children: [{
      path: '/dashboards/rootdashboard',
      name: 'RootDashBoard',
      index: 50,
      meta: {
        breadcrumb: [{
          title: 'RootDashBoard',
          url: '/dashboards/rootdashboard'
        }, {
          title: 'RootDashBoard',
          active: true
        }]
      },
      component: () => import('@/views/dashboards/RootDashboard.vue')
    },
    {
      path: '/call/calling',
      name: 'Calling',
      index: 6,
      component: () => import('@/layout/normal/nodes/Calling.vue')
    },
      {
        path: '/call/moreweixin',
        name: 'MoreWeixin',
        index: 6,
        component: () => import('@/layout/normal/nodes/MoreWeixin.vue')
      },

    {
      path: '/rootsidebarmain/robotui',
      name: 'ROverview',
      index: 50,
      component: () => import('@/views/robot/ROverview.vue')
    },
    {
      path: '/crm/mycustomer',
      name: 'MyCustomer',
      index: 50,
      component: () => import('@/views/crm/CustomerMain.vue')
    },
    {
      path: '/crm/workremain',
      name: 'WorkRemain',
      index: 50,
      component: () => import('@/views/crm/WorkRemain.vue')
    },{
        path: '/mymain/main',
        name: 'MyMain',
        index: 50,
        component: () => import('@/views/mymain/MyMain.vue')
      },
    {
      path: '/crm/dialrecord',
      name: 'DialRecord',
      index: 50,
      component: () => import('@/views/crm/DialRecord.vue')
    },
    {
      path: '/crm/sea',
      name: 'CustomerSea',
      index: 50,
      component: () => import('@/views/crm/CustomerSea.vue')
    },
    {
      path: '/system/rolesmain',
      name: 'RolesMain',
      index: 50,
      component: () => import('@/views/systemset/RolesMain.vue')
    },
    {
      path: '/system/dockset',
      name: 'DockSet',
      index: 50,
      component: () => import('@/views/systemset/DockMain.vue')
    },
    {
      path: '/system/usershow',
      name: 'UserShow',
      index: 50,
      component: () => import('@/views/systemset/UsersMain.vue')
    },
    {
      path: '/system/setstyle',
      name: 'SetStyle',
      index: 50,
      component: () => import('@/views/systemset/SetStyle.vue')
    },{
        path: '/system/baseset',
        name: 'SetStyle',
        index: 50,
        component: () => import('@/views/systemset/BaseSetMain.vue')
    },{
        path: '/system/systemset',
        name: 'SetStyle',
        index: 50,
        component: () => import('@/views/systemset/SystemSetMain.vue')
      },{
        path: '/system/blackset',
        name: 'BlackSet',
        index: 50,
        component: () => import('@/views/systemset/BlackSetMain.vue')
      },{
        path: '/system/thirdmanage',
        name: 'DockManage',
        index: 50,
        component: () => import('@/views/systemset/ThirdMain.vue')
      },{
        path: '/system/usermanagemain',
        name: 'UserManageMain',
        index: 50,
        component: () => import('@/views/systemset/UserManageMain.vue')
      },{
        path: '/site/leavemessage',
        name: 'LeaveMessage',
        index: 50,
        component: () => import('@/views/site/LeaveMessage.vue')
      },{
        path: '/site/documentmanage',
        name: 'DocumentManage',
        index: 50,
        component: () => import('@/views/site/DocumentManage.vue')
      },{
        path: '/bot/botview',
        name: 'BotView',
        index: 50,
        component: () => import('@/views/bot/botview.vue')
      },{
        path: '/bot/botviewmarket',
        name: 'BotView',
        index: 50,
        component: () => import('@/views/bot/botview.vue')
      },{
        path: '/dialcenter/singletask',
        name: 'SingleTask',
        index: 50,
        component: () => import('@/views/dialcenter/SingleTaskMain.vue')
      },{
        path: '/dialcenter/multtask',
        name: 'MultTask',
        index: 50,
        component: () => import('@/views/dialcenter/MultTaskMain.vue')
      },{
        path: '/dialcenter/seatsmanage',
        name: 'MultTask',
        index: 50,
        component: () => import('@/views/dialcenter/SeatsManage.vue')
      },{
        path: '/dialcenter/callin',
        name: 'CallIn',
        index: 50,
        component: () => import('@/views/dialcenter/CallInMain.vue')
      },{
        path: '/dialcenter/callout',
        name: 'CallOut',
        index: 50,
        component: () => import('@/views/dialcenter/CallOutMain.vue')
      },{
        path: '/statistic/mobilestatistic',
        name: 'MobileStatistic',
        index: 50,
        component: () => import('@/views/statistic/MobileStatistic.vue')
      },{
        path: '/bussinesscentral/report',
        name: 'BussinessReport',
        index: 50,
        component: () => import('@/views/business/Report.vue')
      },{
        path: '/bussinesscentral/financial',
        name: 'BussinessReport',
        index: 50,
        component: () => import('@/views/business/Financial.vue')
      },{
        path: '/bussinesscentral/merchant',
        name: 'BussinessMerchant',
        index: 50,
        component: () => import('@/views/business/Merchant.vue')
      },{
        path: '/sms/smsmain',
        name: 'SmsMain',
        index: 50,
        component: () => import('@/views/sms/SmsMain.vue')
      }
      ]
  },
  // 页面找不到时
  {
    path: '*',
    redirect: '/Error404'
  }
]

export default url



// WEBPACK FOOTER //
// ./src/router/url.js